
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import './index.css';


function App() {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
      <BrowserRouter basename="/app">
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
